"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _createReactClass = _interopRequireDefault(require("create-react-class"));

var _react = _interopRequireDefault(require("react"));

var _I18n = _interopRequireDefault(require("I18n"));

var _draftJs = require("draft-js");

var _draftExtend = require("draft-extend");

var _LinkForm = _interopRequireDefault(require("./LinkForm"));

var _EventBoundaryPopover = _interopRequireDefault(require("../../components/EventBoundaryPopover"));

var _isImageBlock = _interopRequireDefault(require("../../utils/isImageBlock"));

var _utils = require("draft-plugins/lib/utils");

var _usageTracking = require("rich-text-lib/constants/usageTracking");

var _Functions = require("UIComponents/core/Functions");

var _SyntheticEvent = _interopRequireDefault(require("UIComponents/core/SyntheticEvent"));

var _Controllable = _interopRequireDefault(require("UIComponents/decorators/Controllable"));

var _getNormalizedLinkData = _interopRequireDefault(require("./getNormalizedLinkData"));

var _default = function _default(Component) {
  return function (getEntityOptions, _ref) {
    var getPages = _ref.getPages,
        showNoFollow = _ref.showNoFollow,
        showTarget = _ref.showTarget,
        onOpenPopover = _ref.onOpenPopover,
        onInsertLink = _ref.onInsertLink,
        popoverPlacement = _ref.popoverPlacement,
        Tracker = _ref.Tracker,
        hideNoFollowConfiguration = _ref.hideNoFollowConfiguration,
        hideTargetConfiguration = _ref.hideTargetConfiguration;
    var LinkPopover = (0, _createReactClass.default)({
      displayName: 'LinkPopoverDecorator',
      propTypes: {
        decoratedText: _propTypes.default.string,
        entityKey: _propTypes.default.string,
        editorState: _propTypes.default.object,
        onChange: _propTypes.default.func,
        onClose: _propTypes.default.func,
        onOpenChange: _propTypes.default.func,
        open: _propTypes.default.bool
      },
      contextTypes: {
        getEditorState: _propTypes.default.func,
        onChange: _propTypes.default.func
      },
      getDefaultProps: function getDefaultProps() {
        return {
          open: false
        };
      },
      getInitialState: function getInitialState() {
        return Object.assign({
          shouldRestoreFocus: false
        }, this.getInitialFormState());
      },
      UNSAFE_componentWillReceiveProps: function UNSAFE_componentWillReceiveProps(nextProps) {
        if (this.isNew()) {
          return;
        }

        var nextEntityKey = nextProps.entityKey;
        var currentEntityKey = this.props.entityKey;

        if (nextEntityKey !== currentEntityKey) {
          this.setState(this.getInitialFormState(nextProps));
        }
      },
      getInitialFormState: function getInitialFormState() {
        var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;

        if (this.isImageSelected()) {
          var imageBlock = this.getSelectedBlock();
          var linkData = imageBlock.getData().get('link');

          if (linkData) {
            var _getNormalizedLinkDat = (0, _getNormalizedLinkData.default)(linkData.toObject()),
                _isNoFollow = _getNormalizedLinkDat.isNoFollow,
                _isTargetBlank = _getNormalizedLinkDat.isTargetBlank,
                _url = _getNormalizedLinkDat.url;

            if (_url === null) {
              _url = '';
            }

            if (_isTargetBlank === null) {
              _isTargetBlank = true;
            }

            if (_isNoFollow === null) {
              _isNoFollow = false;
            }

            return {
              isNoFollow: _isNoFollow,
              isTargetBlank: _isTargetBlank,
              url: _url
            };
          }
        }

        if (this.isNew()) {
          var _this$getEditorData = this.getEditorData(),
              editorState = _this$getEditorData.editorState;

          var text = '';
          var selection = editorState.getSelection();

          if (selection.getStartKey() === selection.getEndKey()) {
            var block = editorState.getCurrentContent().getBlockForKey(selection.getStartKey());
            text = block.getText().slice(selection.getStartOffset(), selection.getEndOffset());
          }

          return {
            isNoFollow: showNoFollow,
            isTargetBlank: showTarget,
            text: text,
            url: ''
          };
        }

        var decoratedText = props.decoratedText;

        var _getNormalizedLinkDat2 = (0, _getNormalizedLinkData.default)(this.getEntity(props.entityKey).getData(), {
          showNoFollow: showNoFollow,
          showTarget: showTarget
        }),
            isNoFollow = _getNormalizedLinkDat2.isNoFollow,
            isTargetBlank = _getNormalizedLinkDat2.isTargetBlank,
            url = _getNormalizedLinkDat2.url;

        return {
          url: url,
          isNoFollow: isNoFollow,
          isTargetBlank: isTargetBlank,
          text: decoratedText
        };
      },
      isNew: function isNew() {
        var entityKey = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props.entityKey;
        return entityKey === undefined;
      },
      isImageSelected: function isImageSelected() {
        var selectedBlock = this.getSelectedBlock();

        if (!selectedBlock) {
          return false;
        }

        return (0, _isImageBlock.default)(selectedBlock);
      },
      getSelectedBlock: function getSelectedBlock() {
        var _this$getEditorData2 = this.getEditorData(),
            editorState = _this$getEditorData2.editorState;

        var currentSelection = editorState.getSelection();
        var currentBlockKey = currentSelection.getFocusKey();
        var currentContent = editorState.getCurrentContent();
        return currentContent.getBlockForKey(currentBlockKey);
      },
      getEditorData: function getEditorData() {
        var _this$context = this.context,
            getEditorState = _this$context.getEditorState,
            onChange = _this$context.onChange;

        if (getEditorState && onChange) {
          return {
            editorState: getEditorState(),
            onChange: onChange
          };
        }

        return {
          editorState: this.props.editorState,
          onChange: this.props.onChange
        };
      },
      getEntity: function getEntity() {
        var entityKey = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props.entityKey;

        if (this.isNew(entityKey)) {
          return null;
        }

        var contentState = this.getEditorData().editorState.getCurrentContent();
        return contentState.getEntity(entityKey);
      },
      togglePopover: function togglePopover() {
        var _this$props = this.props,
            onOpenChange = _this$props.onOpenChange,
            open = _this$props.open;
        onOpenChange((0, _SyntheticEvent.default)(!open));
        var shouldRestoreFocus = false;

        if (open === false) {
          onOpenPopover();
          var selection = this.getEditorData().editorState.getSelection();
          shouldRestoreFocus = selection.getHasFocus();
        }

        this.setState(Object.assign({
          shouldRestoreFocus: shouldRestoreFocus
        }, this.getInitialFormState()));
      },
      setImageLinkData: function setImageLinkData() {
        var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
        var isTargetBlank = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

        var _this$getEditorData3 = this.getEditorData(),
            editorState = _this$getEditorData3.editorState,
            onChange = _this$getEditorData3.onChange;

        if (this.isImageSelected()) {
          var selectedBlock = this.getSelectedBlock();
          var oldData = selectedBlock.getData();
          var newData = oldData.update('link', function (link) {
            return link.merge({
              url: url,
              isTargetBlank: isTargetBlank
            });
          });

          var blockSelection = _draftJs.SelectionState.createEmpty(selectedBlock.getKey());

          var contentStateWithImageLink = _draftJs.Modifier.mergeBlockData(editorState.getCurrentContent(), blockSelection, newData);

          var editorStateWithImageLink = _draftJs.EditorState.push(editorState, contentStateWithImageLink, 'change-block-data');

          onChange(editorStateWithImageLink);
          return editorStateWithImageLink;
        }

        return editorState;
      },
      handleClose: function handleClose() {
        var targetEditorState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
        var _this$props2 = this.props,
            onClose = _this$props2.onClose,
            onOpenChange = _this$props2.onOpenChange;
        var _this$state = this.state,
            shouldRestoreFocus = _this$state.shouldRestoreFocus,
            url = _this$state.url;

        if (!this.isNew() && (!url || url.trim().length === 0)) {
          this.handleRemove();
        }

        if (shouldRestoreFocus) {
          var _this$getEditorData4 = this.getEditorData(),
              editorState = _this$getEditorData4.editorState,
              onChange = _this$getEditorData4.onChange;

          var finalEditorState = targetEditorState || editorState;
          onChange(_draftJs.EditorState.forceSelection(finalEditorState, finalEditorState.getSelection()));
        }

        (0, _Functions.callIfPossible)(onClose);
        onOpenChange((0, _SyntheticEvent.default)(false));
        this.setState(this.getInitialState());
      },
      handleRemove: function handleRemove() {
        if (this.isImageSelected()) {
          this.setImageLinkData();
          this.setState({
            url: '',
            isTargetBlank: true
          });
        } else if (!this.isNew()) {
          var entityKey = this.props.entityKey;

          var _this$getEditorData5 = this.getEditorData(),
              editorState = _this$getEditorData5.editorState,
              onChange = _this$getEditorData5.onChange;

          var selection = _draftExtend.pluginUtils.getEntitySelection(editorState, entityKey);

          onChange(_draftJs.RichUtils.toggleLink(editorState, selection, null));
        }
      },
      handleConfirm: function handleConfirm() {
        var decoratedText = this.props.decoratedText;

        var _this$getEditorData6 = this.getEditorData(),
            editorState = _this$getEditorData6.editorState,
            onChange = _this$getEditorData6.onChange;

        var _this$state2 = this.state,
            isNoFollow = _this$state2.isNoFollow,
            isTargetBlank = _this$state2.isTargetBlank,
            text = _this$state2.text,
            url = _this$state2.url;
        var urlWithProtocol = (0, _utils.ensureUrlHasProtocol)(url); // LI-197

        var encodedUrl = (0, _utils.encodeUrl)(urlWithProtocol);
        var selection = editorState.getSelection();
        var updatedEditorState = editorState;

        if (this.isImageSelected()) {
          updatedEditorState = this.setImageLinkData(url, isTargetBlank);
        } else if (this.isNew()) {
          var _editorState$getCurre;

          var contentStateWithEntity = editorState.getCurrentContent();
          contentStateWithEntity = (_editorState$getCurre = editorState.getCurrentContent()).createEntity.apply(_editorState$getCurre, (0, _toConsumableArray2.default)(getEntityOptions(encodedUrl, isTargetBlank, isNoFollow)));
          var entityKey = contentStateWithEntity.getLastCreatedEntityKey();
          var linkStyles = editorState.getCurrentInlineStyle().filter(function (style) {
            // remove all non-text-color styles (but leave 'background-color', which
            // unfortunately is a superstring of 'color')
            return style.includes('background-color') || !style.includes('color');
          });
          var modifierMethod = selection.isCollapsed() ? _draftJs.Modifier.insertText : _draftJs.Modifier.replaceText;
          updatedEditorState = _draftJs.EditorState.push(editorState, modifierMethod(contentStateWithEntity, selection, text, linkStyles, entityKey), 'insert-characters');
          updatedEditorState = _draftJs.EditorState.forceSelection(updatedEditorState, updatedEditorState.getCurrentContent().getSelectionAfter());
          updatedEditorState = _draftJs.EditorState.setInlineStyleOverride(updatedEditorState, editorState.getCurrentInlineStyle());
          onChange(updatedEditorState);
        } else {
          var _entityKey = this.props.entityKey;

          var entitySelection = _draftExtend.pluginUtils.getEntitySelection(editorState, _entityKey);

          var contentState = editorState.getCurrentContent();
          contentState = contentState.mergeEntityData(_entityKey, {
            isNoFollow: isNoFollow,
            isTargetBlank: isTargetBlank,
            url: encodedUrl
          });
          updatedEditorState = _draftJs.EditorState.push(editorState, _draftJs.Modifier.applyEntity(contentState, editorState.getSelection(), _entityKey), 'update-entity');

          if (text !== decoratedText) {
            var entityStyles = _draftExtend.pluginUtils.getSelectedInlineStyles(_draftJs.EditorState.forceSelection(updatedEditorState, entitySelection));

            updatedEditorState = _draftJs.EditorState.push(updatedEditorState, _draftJs.Modifier.replaceText(updatedEditorState.getCurrentContent(), entitySelection, text, entityStyles, _entityKey), 'update-entity');
            onChange(updatedEditorState);
          } else {
            onChange(updatedEditorState);
          }
        }

        Tracker.track('draftLink', {
          action: _usageTracking.INSERT_LINK,
          noFollow: isNoFollow,
          externalLink: isTargetBlank,
          isImage: this.isImageSelected()
        });
        (0, _Functions.callIfPossible)(onInsertLink);
        this.setState(this.getInitialState());
        this.handleClose(updatedEditorState);
      },
      handleChange: function handleChange(state) {
        this.setState(state);
      },
      renderPopoverContent: function renderPopoverContent() {
        var isNew = this.isNew();
        var _this$state3 = this.state,
            isNoFollow = _this$state3.isNoFollow,
            isTargetBlank = _this$state3.isTargetBlank,
            text = _this$state3.text,
            url = _this$state3.url;
        var linkFormProps = {};
        var isImageSelected = this.isImageSelected();

        if (isImageSelected) {
          linkFormProps.headerText = _I18n.default.text('draftPlugins.linkPlugin.imageLink');
        }

        var pages = getPages ? getPages() : [];
        return _react.default.createElement(_LinkForm.default, Object.assign({
          isNew: isNew && !isImageSelected,
          showText: !isImageSelected,
          text: text,
          url: url,
          isTargetBlank: isTargetBlank,
          isNoFollow: isNoFollow,
          hideNoFollowConfiguration: hideNoFollowConfiguration,
          hideTargetConfiguration: hideTargetConfiguration,
          onChange: this.handleChange,
          onConfirm: this.handleConfirm,
          onCancel: this.handleClose,
          onRemove: this.handleRemove,
          pages: pages
        }, linkFormProps));
      },
      render: function render() {
        var open = this.props.open;

        if (!Component) {
          // not wrapping a button so we're already in a popover
          return this.renderPopoverContent();
        }

        return _react.default.createElement(_EventBoundaryPopover.default, {
          closeOnOutsideClick: true,
          className: "richtext-link",
          open: open,
          Content: this.renderPopoverContent,
          pinToConstraint: true,
          animateOnToggle: false,
          placement: popoverPlacement
        }, _react.default.createElement(Component, Object.assign({}, this.props, {
          togglePopover: this.togglePopover
        })));
      }
    });
    return (0, _Controllable.default)(LinkPopover, ['open']);
  };
};

exports.default = _default;
module.exports = exports.default;